/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Live usage as reported by OpenRouter at request time.
 */
export type GetKeyUsageResponseBody = {
  /**
   * Credits spent this month, rounded to cents.
   */
  creditsUsed: number;
  /**
   * Monthly credit ceiling recorded locally.
   */
  monthlyCredits: number;
  /**
   * Monthly limit as configured upstream; absent when OpenRouter reports an unlimited key.
   */
  upstreamLimit?: number | undefined;
};

/** @internal */
export const GetKeyUsageResponseBody$inboundSchema: z.ZodMiniType<
  GetKeyUsageResponseBody,
  unknown
> = z.pipe(
  z.object({
    credits_used: z.number(),
    monthly_credits: z.int(),
    upstream_limit: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "credits_used": "creditsUsed",
      "monthly_credits": "monthlyCredits",
      "upstream_limit": "upstreamLimit",
    });
  }),
);

export function getKeyUsageResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetKeyUsageResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetKeyUsageResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetKeyUsageResponseBody' from JSON`,
  );
}
